import { CUBE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';

const ONE_TO_ONE_CHANNELS_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });
  const query: CubeQuery = {
    dimensions: [`${sourceCube}.interaction_type_lvl_2`],
    limit: 1000,
    filters: [
      { member: `${sourceCube}.is_1to1visit`, operator: 'equals' as const, values: ['1'] },
      { member: `${sourceCube}.hcp_bk`, operator: 'set' as const },
    ],
    timeDimensions: [timeDimensions],
  };
  return query;
};

const oneToOneChannelsFilter: FilterConfigDynamic = {
  searchable: true,
  label: 'main.channelFocus.hcpCoverage.filters.oneToOne.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.oneToOne.placeholder',
  type: 'multiselect',
  clearable: true,
  getOptionsQuery: ONE_TO_ONE_CHANNELS_OPTIONS,
  sourceCube: CUBE_AGGREGATE_INTERACTION,
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION}.interaction_type_lvl_2`),
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CUBE_AGGREGATE_INTERACTION}.interaction_type_lvl_2`,
      operator: 'equals',
      values: [...v],
    };
  },
  defaultValue: [],
};

export default oneToOneChannelsFilter;
